import type { AasApiAdapter, McpProbeInput, UpsertMcpServerInput } from "../adapter";
import { requestJson } from "../http";
import type { McpOAuthConnectResult, McpProbeResult, McpServer, McpServerPreset } from "../types";

export const mcpApi: AasApiAdapter["mcp"] = {
	list(slug: string) {
		return requestJson<McpServer[]>(`/api/agents/${encodeURIComponent(slug)}/mcp-servers`);
	},
	presets() {
		return requestJson<McpServerPreset[]>("/api/agents/mcp-presets");
	},
	connectOAuth(slug, name, input) {
		return requestJson<McpOAuthConnectResult>(
			`/api/agents/${encodeURIComponent(slug)}/mcp-servers/${encodeURIComponent(name)}/oauth/connect`,
			{ method: "POST", body: input },
		);
	},
	disconnectOAuth(slug, name) {
		return requestJson<{ disconnected: true; providerRevoked: boolean }>(
			`/api/agents/${encodeURIComponent(slug)}/mcp-servers/${encodeURIComponent(name)}/oauth/disconnect`,
			{ method: "POST" },
		);
	},
	probe(slug: string, input: McpProbeInput) {
		return requestJson<McpProbeResult>(`/api/agents/${encodeURIComponent(slug)}/mcp/probe`, {
			method: "POST",
			body: { server: input },
		});
	},
	async upsert(slug: string, input: UpsertMcpServerInput) {
		await requestJson(`/api/agents/${encodeURIComponent(slug)}/mcp-servers`, {
			method: "POST",
			body: input,
		});
	},
	async delete(slug: string, name: string) {
		await requestJson<void>(
			`/api/agents/${encodeURIComponent(slug)}/mcp-servers/${encodeURIComponent(name)}`,
			{ method: "DELETE" },
		);
	},
};
